<template>
	<div>
		<tinymce-editor
			:init="computedInit"
			class="tinymce-editor"
			:value="computedContent"
			@input="onInput($event)"
		/>
	</div>
</template>

<script>
// List of available plugins - https://www.tiny.cloud/docs/plugins
import "tinymce/tinymce"
import "tinymce/icons/default/icons"
import "tinymce/themes/silver/theme"
import "tinymce/plugins/paste/plugin"
import "tinymce/plugins/lists/plugin"
import "tinymce/plugins/advlist/plugin"
import "tinymce/plugins/table/plugin"
import "tinymce/plugins/code/plugin"
import "tinymce/plugins/link/plugin"
import "tinymce/plugins/image/plugin"
import "tinymce/plugins/pagebreak/plugin"
import "tinymce/plugins/searchreplace/plugin"
import "tinymce/plugins/hr/plugin"
import "tinymce/plugins/fullscreen/plugin"
import "tinymce/plugins/nonbreaking/plugin"

// skins
import "../../../../../skins/ui/oxide/skin.css"

import Editor from "@tinymce/tinymce-vue"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import debounce from "lodash.debounce"

export default {
	components: {
		"tinymce-editor": Editor
	},

	props: {
		content: null,

		delay: {
			type: Number,
			default: 500,
			required: false
		},

		fetchFilesFor: null, // templates

		hasMenuBar: {
			type: Boolean,
			default: () => true
		},

		toolbarConfig: {
			type: [Array, String],
			default: () => "default"
		}
	},

	data() {
		return {
			timer: null,
			init: {
				skin: false,
				height: 440,
				branding: false,
				menubar: this.hasMenuBar,
				plugins: [
					"lists",
					"advlist",
					"bold",
					"table",
					"code",
					"link",
					"image",
					"pagebreak",
					"hr",
					"searchreplace",
					"fullscreen",
					"nonbreaking"
				],
				toolbar: null,
				valid_children: "+body[style]", // allow style tags in html
				forced_root_block: false,
				nonbreaking_force_tab: true,
				pagebreak_separator: "<div style='page-break-after: always;'></div>",
				image_list: async success => {
					success(await this.fetchFiles())
				},
				file_picker_types: "image"
			},

			defaultToolBar: [
				"undo",
				"redo",
				"fontselect",
				"fontsizeselect",
				"bold",
				"italic",
				"alignleft",
				"aligncenter",
				"alignright",
				"alignjustify",
				"link",
				"image",
				"numlist",
				"bullist",
				"pagebreak",
				"hr",
				"searchreplace",
				"nonbreaking"
			]
		}
	},
	methods: {
		onInput($event) {
			clearTimeout(this.timer)

			this.timer = setTimeout(() => {
				this.$emit("input", $event)
			}, this.computedDelay)
		},

		async fetchFiles() {
			let query = gql`
				query fetchTempalteFiles($for: String) {
					fileListing(prefix: $for) {
						objectSummaries {
							fileName
							key
						}
					}
				}
			`

			let variables = null

			if (this.fetchFilesFor === "templateAssets") {
				variables = { for: "templates/assets/" }
			}

			const res = await api({ query, variables })

			return res?.data?.fileListing?.objectSummaries
				?.filter(item => {
					if (
						item.fileName.includes("png") ||
						item.fileName.includes("jpg") ||
						item.fileName.includes("jpeg")
					)
						return true
				})
				?.map(item => ({
					title: item.fileName,
					value: `https://api.asia.covergo.com/api/v1/files/${encodeURIComponent(
						item.key
					)}?tenantIdIfNoToken=${this.$store.state.tenantId}`
				}))
		},

		decideToolBar() {
			//  default value
			if (this.toolbarConfig === "default") {
				return this.defaultToolBar?.join(" ")
			} else return this.toolbarConfig?.join(" ")
		}
	},

	computed: {
		computedContent() {
			return this.content
		},
		computedDelay() {
			return this.delay
		},
		computedInit() {
			return {
				...this.init,
				toolbar: this.decideToolBar()
			}
		}
	}
}
</script>
